// extracted by css-extract-rspack-plugin
export default {"radio":"radio-A38XPs","checked":"checked-obvNhr"};